function enrichSnapshotWithId(querySnapshot) {
  const data = [];
  querySnapshot.forEach((doc) => {
    const elem = doc.data();
    elem.id = doc.id;
    data.push(elem);
  });
  return data;
}

module.exports = function () {
  return {
    //==============================================================================
    // Candidates Collection
    //==============================================================================
    getCandidatesForCampaign(campaignId) {
      return new Promise((fullfil, reject) => {
        this.collection("candidates")
          .where("campaignId", "==", campaignId)
          .then((querySnapshot) => fullfil(enrichSnapshotWithId(querySnapshot)))
          .catch(reject);
      });
    },
    getCandidatesByCampaignIdAndAppliedAfterDate(campaignId, appliedDate) {
      return new Promise((fullfil, reject) => {
        this.collection("candidates")
          .where("campaignId", "==", campaignId)
          .where("appliedDate", ">=", appliedDate)
          .where("effectiveStatus", "==", "active")
          .get()
          .then((snapshot) => fullfil(enrichSnapshotWithId(snapshot)))
          .catch(reject);
      });
    }
  };
};
